import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import Tooltip from '../Tooltip/Tooltip';
import styles from './CopyableItem.css';
import useTranslate from '../../../hooks/useTranslate';

const CopyableItem = ({ label, item }) => {
  const buttonRef = useRef(null);
  const i18n = useTranslate();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyItem = useCallback(() => {
    if (item) {
      navigator.clipboard.writeText(item);
      setIsCopied(true);
    }
  }, [item]);

  const handleMouseLeave = () => {
    setIsCopied(false);
  };

  return (
    <div className={styles.CopyableItem}>
      <div className={styles.CopyableItem__label}>
        {label}
        <Tooltip anchor={buttonRef} direction="right">
          {isCopied ? i18n('WasCopied') : i18n('Copy')}
        </Tooltip>
        <Button
          ref={buttonRef}
          type="button"
          rounded
          flat
          icon="copy"
          tabIndex={-1}
          onClick={handleCopyItem}
          onMouseLeave={handleMouseLeave}
          className={styles.CopyableItem__button}
        />
      </div>
      <div className={styles.CopyableItem__item}>
        {item}
      </div>
    </div>
  );
};

CopyableItem.propTypes = {
  label: PropTypes.string,
  item: PropTypes.string,
};

export default CopyableItem;
